<template>
	<v-dialog
		id="bulkEdit"
		v-model="showDialog"
		max-width="800"
		:scrollable="true"
		persistent
	>
		<v-card>
			<v-card-title> Bulk Edit </v-card-title>
			<v-card-text>
				<div class="grid-flex-container">
					<div
						class="d-sm-block flex-column flex-wrap flex-grow-1"
						:class="getOverflowYClass"
					>
						<div
							class="px-4 py-2"
							:class="getGVFClass"
							v-for="(field, index) in visibleFields"
							:key="index"
						>
							<GridField
								:tabIndex="getTabIndex(field)"
								:gridViewField="field"
								:defaultGridView="defaultGridView"
								:isBulkEdit="true"
							/>
						</div>
					</div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn @click.stop="onClose">Close</v-btn>
				<v-btn color="primary" @click.stop="onSave">
					<v-icon class="mr-2">mdi-content-save</v-icon>
					Save
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import projectSettingsMixin from '../../../mixins/projectSettingsMixin';
import { GridsGetters, GridsPageEditGetters } from '../../../store/getters';
import { GridsPageEditActions } from '../../../store/actions';
import { gridViewTypes } from '../../../enums/gridViewTypes';
import GridField from './GridField.vue';
export default {
	name: 'BulkEditModal',
	mixins: [projectSettingsMixin],
	components: {
		GridField,
	},
	props: {
		showDialog: Boolean,
		selectedRows: Array,
	},
	data() {
		return {};
	},
	computed: {
		...mapGetters({
			entities: [GridsGetters.GET_ENTITIES],
			gridViews: [GridsGetters.GET_GRID_VIEWS],
			record: [GridsPageEditGetters.RECORD],
		}),

		visibleFields() {
			if (!this.defaultGridView) return [];
			return this.defaultGridView.Columns.filter(
				(x) => x.IsVisibleEditForm === true
			).sort((a, b) => a.Order - b.Order);
		},
		defaultGridView() {
			if (!this.selectedEntity) return null;
			if (!this.gridViews) return null;
			return this.gridViews.find(
				(x) =>
					x.EntityId === this.selectedEntity.Id &&
					x.UserId === null &&
					x.Type === gridViewTypes.Grids
			);
		},
		selectedEntity() {
			if (!this.entityType) return null;
			if (!this.entities) return null;
			return this.entities.find((x) => x.Name === this.entityType);
		},
		getGVFClass() {
			if (!this.$vuetify.breakpoint.mdAndUp) return 'gvf-sm';
			let width = this.getGridsColumnWidth(this.entityType);
			if (width === '1') return 'gvf-sm';
			if (width === '2') return 'gvf-md';
			return 'gvf-sm';
		},
		getOverflowYClass() {
			let width = this.getGridsColumnWidth(this.entityType);
			if (width === '1') return 'overflow-y-auto';
			if (width === '2') {
				if (!this.$vuetify.breakpoint.mdAndUp) return 'overflow-y-auto';
				return 'd-md-flex overflow-y-hidden';
			}
			return 'overflow-y-auto';
		},
		entityType() {
			return this.$route.params.pageName;
		},
	},
	destroyed() {
		this.$store.dispatch(GridsPageEditActions.CLEAR);
	},
	methods: {
		onClose() {
			this.$emit('close');
		},
		onSave() {
			this.$store.dispatch(GridsPageEditActions.BULK_EDIT, {
				SelectedEntityName: this.entityType,
				SelectedRows: this.selectedRows,
				Record: JSON.stringify(this.record),
			});
			this.$emit('save');
		},
		getTabIndex(gvf) {
			let offset = 1;
			if (this.visibleFields && this.visibleFields.length > 0) {
				let index = this.visibleFields.indexOf(gvf);
				if (index > 0) offset = offset + index;
			}
			return 100 + offset;
		},
	},
};
</script>
<style lang="scss">
.gvf-sm {
	width: 100%;
}
.gvf-md {
	width: 50%;
}
</style>
